import React from "react";

const businessTypes = [
    "Individual",
    "Startup",
    "Small Business",
    "Company",
    "Agency",
    "Freelancer",
    "NGO",
    "Educational",
    "Government",
    "Other"
];

const categories = [
    "Fashion",
    "Electronics",
    "Beauty",
    "Health",
    "Food & Beverage",
    "Home & Living",
    "Sports",
    "Automobile",
    "Education",
    "Travel",
    "Photography",
    "Music",
    "Technology",
    "Finance",
    "Real Estate",
    "Marketing",
    "Consulting",
    "Art",
    "Entertainment",
    "Services",
    "Other"
];

export default function BrandStep1({

    form,

    updateField

}) {

    const logoPreview =
        form.logo
            ? URL.createObjectURL(form.logo)
            : null;

    return (

        <div>

            <h2
                style={{
                    marginBottom: 6
                }}
            >
                Brand Information
            </h2>

            <p
                style={{
                    color: "#777",
                    marginBottom: 28
                }}
            >
                Tell us about your brand.
            </p>

            {/* Logo */}

            <div
                style={{
                    marginBottom: 30,
                    textAlign: "center"
                }}
            >

                <div
                    style={{
                        width: 140,
                        height: 140,
                        margin: "0 auto 16px",
                        borderRadius: 18,
                        overflow: "hidden",
                        background: "#f3f3f3",
                        border: "2px dashed #ccc",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >

                    {logoPreview ? (

                        <img
                            src={logoPreview}
                            alt=""
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover"
                            }}
                        />

                    ) : (

                        <span
                            style={{
                                color: "#999",
                                fontSize: 14
                            }}
                        >
                            Brand Logo
                        </span>

                    )}

                </div>

                <input
                    type="file"
                    accept="image/*"
                    onChange={(e)=>{

                        if(e.target.files.length){

                            updateField(
                                "logo",
                                e.target.files[0]
                            );

                        }

                    }}
                />

            </div>

            {/* Brand Name */}

            <div
                style={{
                    marginBottom: 22
                }}
            >

                <label
                    style={{
                        display: "block",
                        marginBottom: 8,
                        fontWeight: 600
                    }}
                >
                    Brand Name *
                </label>

                <input

                    type="text"

                    value={form.brandName}

                    onChange={(e)=>

                        updateField(
                            "brandName",
                            e.target.value
                        )

                    }

                    placeholder="Example: myFAVV Studio"

                    style={{
                        width: "100%",
                        padding: 14,
                        borderRadius: 10,
                        border: "1px solid #ddd",
                        fontSize: 15,
                        outline: "none"
                    }}

                />

            </div>

            {/* Business Type */}

            <div
                style={{
                    marginBottom: 22
                }}
            >

                <label
                    style={{
                        display: "block",
                        marginBottom: 8,
                        fontWeight: 600
                    }}
                >
                    Business Type *
                </label>

                <select

                    value={form.businessType}

                    onChange={(e)=>

                        updateField(
                            "businessType",
                            e.target.value
                        )

                    }

                    style={{
                        width: "100%",
                        padding: 14,
                        borderRadius: 10,
                        border: "1px solid #ddd",
                        fontSize: 15
                    }}

                >

                    <option value="">
                        Select Business Type
                    </option>

                    {businessTypes.map(type=>(

                        <option
                            key={type}
                            value={type}
                        >
                            {type}
                        </option>

                    ))}

                </select>

            </div>

            {/* Category */}

            <div
                style={{
                    marginBottom: 22
                }}
            >

                <label
                    style={{
                        display: "block",
                        marginBottom: 8,
                        fontWeight: 600
                    }}
                >
                    Category *
                </label>

                <select

                    value={form.category}

                    onChange={(e)=>

                        updateField(
                            "category",
                            e.target.value
                        )

                    }

                    style={{
                        width: "100%",
                        padding: 14,
                        borderRadius: 10,
                        border: "1px solid #ddd",
                        fontSize: 15
                    }}

                >

                    <option value="">
                        Select Category
                    </option>

                    {categories.map(category=>(

                        <option
                            key={category}
                            value={category}
                        >
                            {category}
                        </option>

                    ))}

                </select>

            </div>

            {/* Tagline */}

            <div>

                <label
                    style={{
                        display: "block",
                        marginBottom: 8,
                        fontWeight: 600
                    }}
                >
                    Brand Tagline
                </label>

                <textarea

                    rows={3}

                    value={form.tagline}

                    onChange={(e)=>

                        updateField(
                            "tagline",
                            e.target.value
                        )

                    }

                    placeholder="A short line describing your brand..."

                    style={{
                        width: "100%",
                        padding: 14,
                        borderRadius: 10,
                        border: "1px solid #ddd",
                        resize: "vertical",
                        fontSize: 15
                    }}

                />

            </div>

            {/* Summary */}

            <div
                style={{
                    marginTop: 35,
                    padding: 20,
                    borderRadius: 12,
                    background: "#F8FAFC",
                    border: "1px solid #E2E8F0"
                }}
            >

                <div
                    style={{
                        fontWeight: 600,
                        marginBottom: 10
                    }}
                >
                    Preview
                </div>

                <div
                    style={{
                        color: "#555",
                        lineHeight: 1.7
                    }}
                >

                    <div>

                        <strong>Brand:</strong>{" "}
                        {form.brandName || "-"}

                    </div>

                    <div>

                        <strong>Business:</strong>{" "}
                        {form.businessType || "-"}

                    </div>

                    <div>

                        <strong>Category:</strong>{" "}
                        {form.category || "-"}

                    </div>

                    <div>

                        <strong>Tagline:</strong>{" "}
                        {form.tagline || "-"}

                    </div>

                </div>

            </div>

        </div>

    );

}